import AccountView from './AccountView';
import ScrollView from './ScrollView';
import Center from './Center'
const View = {
    AccountView: AccountView,
    ScrollView: ScrollView,
    Center: Center
}

export default View;
